import apexchart from "../../../../node_modules/vue-apexcharts";
import {globalFunctions} from '@/mixins/globalFunctions'


export default {
  mixins:[globalFunctions],
  data() {
    return {
      apexheight: globalFunctions.getScreenWidth(),
      portfolioScoreChartOptions: {
        tooltip: {
          enabled: false,
          shared: false,
          x: {
            formatter(val) {
              return val;
            },
          },
          y: {
            formatter(val) {
              return `${Math.abs(val)}`;
            },
          },
        },
        chart: {
          type: "radialBar",
          offsetY: -20,
          offsetX: 250,
          sparkline: {
            enabled: true,
          },
          height: "400px",
        },
        colors: ["#ecf018"],
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#000000",
              strokeWidth: "100%",
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#999",
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              show: true,
              name: {
                show: false,
              },
              value: {
                show: true,
                fontSize: screen.width > 500 ? '24px': '10px',
                fontFamily: undefined,
                fontWeight: 600,
                color: "#fff",
                offsetY: -8,
                formatter: function (val,opts) {
                  return val;
                },
              },
            },
            hollow: {
              margin: 50,
              size: "38%",
              background: "#000000",
              image: undefined,
              imageWidth: 150,
              imageHeight: 150,
              imageOffsetX: 0,
              imageOffsetY: 0,
              imageClipped: true,
              position: "front",
              dropShadow: {
                enabled: false,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.5,
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#f06616'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: "butt",
        },
        labels: ["Portfolio Score"],
      },
      series: [this.getFixedVal(this.PortfolioScoreCardTotalScore.Pct_score)],
      portfolioHeader: this.PortfolioScoreCardTotalScore.Pct_score >= 85 ? 'GREAT' : this.PortfolioScoreCardTotalScore.Pct_score >= 65 ? 'GOOD' : this.PortfolioScoreCardTotalScore.Pct_score >= 45 ? 'FAIR' : this.PortfolioScoreCardTotalScore.Pct_score >= 20 ? 'POOR' : 'VERY POOR',

      }
  },

  props: ['user',
  "PortfolioScoreCardBehaviour",
  "PortfolioScoreCardFundamental",
  "PortfolioScoreCardPortfolio",
  "PortfolioScoreCardTechnical",
  "PortfolioScoreCardTotalScore"],

  components: { apexchart},

  watch: {
    // user(val) {
    //   this.series  = val.isPrem ? [this.getFixedVal(this.PortfolioScoreCardTotalScore.Pct_score)] : [50];
    //   this.portfolioScoreChartOptions.plotOptions.radialBar.hollow.image = val.isPrem ? '': require('../../img/apexLock.svg') ;
    // },
    // 'portfolioScoreChartOptions.plotOptions': {
    //   deep: true,
    //   handler(newValue, oldValue) {
    //     this.portfolioScoreChartOptions.plotOptions.radialBar.dataLabels.show = this.user.isPrem ? true: false;
    //     this.$refs.barChart.updateOptions(this.portfolioScoreChartOptions);
    //   }
    // }
  },
  created() {
      // this.series  = this.user.isPrem ? [this.getFixedVal(this.PortfolioScoreCardTotalScore.Pct_score)] : [50];
      // this.portfolioScoreChartOptions.plotOptions.radialBar.hollow.image = this.user.isPrem ? undefined: require('../../img/apexLock.svg');
  },

  methods: {
    calculateScorePct(value) {
      return `width: ${value}%`;
    },
    getFixedVal(value) {
      if (
        value === null ||
        value === ""|| parseFloat(value) >= 9999 || parseFloat(value) <= -9999
      ) {
        return "NA";
      }
      else if(isNaN(value)){
        return value
      }
      else {
        return parseFloat(value).toFixed(1);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Report/portfolioScoreCard.js